import styled from "styled-components/macro";

function TabPanel(props) {
  return <StyledTabPanel show={props.show}>{props.children}</StyledTabPanel>;
}

export default TabPanel;

const StyledTabPanel = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};

  padding-top: 1rem;
  padding-bottom: 1rem;

  svg {
    height: 22px;
    width: 22px;
  }
  ul,
  p {
    margin-top: 2px;
    margin-bottom: 4px;
  }
  * {
    font-size: 0.875rem;
  }
`;
